import { useState } from "react";
import { FaqSectionProps } from "../custom-drawer/CustomDrawerTypes";
import {
  Image,
  Linking,
  Platform,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import { Text } from "react-native";
import { DROPDOWN_ARROW_DARK } from "src/resources/IMAGES";
import { LinkedText } from "./LinkedText";
import { theme } from "src/theme/theme";
import { COLORS } from "src/theme/constants";
import Color from "src/assets/color/Color";
import { getCompanyName } from "@lib/utilities/Constants";
import { urls } from "src/resources/strings";
import { ScrollView } from "react-native";
import { getFormattedLabelText } from "@lib/utilities/Formatters";

const FaqSection: React.FC<FaqSectionProps> = ({ data, onNavigate }) => {
  const [expandedId, setExpandedId] = useState<number | null>(null);

  const toggle = (id: number) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  const handleLearnMore = () => {
    Linking.openURL(String(urls.faqURL));
  };

  const brandName = getCompanyName()

  return (
    <View style={styles.flex}>
    <ScrollView style={styles.faqContentContainer} showsVerticalScrollIndicator>
      {data.map((item) => {
        const isExpanded = expandedId === item.id;

        return (
          <View key={item.id} style={styles.faqQuestionContainer}>
            <TouchableOpacity
              style={styles.rowApart}
              onPress={() => toggle(item.id)}
              activeOpacity={0.7}
            >
              <Text style={styles.faqQuestionTxt}>{item.question}</Text>
              <Image
                style={[
                  styles.faqDropdownCollapsedIcon,
                  isExpanded && styles.faqDropdownExpandIcon,
                ]}
                source={DROPDOWN_ARROW_DARK}
              />
            </TouchableOpacity>

            {isExpanded && (
              <>
                {typeof item?.answer === "string" ? (
                  <LinkedText
                    text={item?.answer}
                    links={item.links}
                    textStyle={styles.faqAnswerTxt}
                    onNavigate={onNavigate}
                  />
                ) : (
                  <>
                    {item?.answer.map((ans, index) => (
                      <LinkedText
                        text={ans}
                        links={item.links}
                        textStyle={styles.faqAnswerTxt}
                        onNavigate={onNavigate}
                      />
                    ))}
                  </>
                )}
              </>
            )}
          </View>
        );
      })}
      {urls.faqURL && getCompanyName() == "PRAXIS" && (
        <View style={styles.learnMoreContainer}>
          <Text style={styles.learnMoreText}>
            <Text style={styles.learnMoreLink} onPress={handleLearnMore}>
              Learn more
            </Text>{" "}
            about the enhanced coverage{" "}
            {getFormattedLabelText(brandName)}{" "}
            provides for Florida homeowners.
          </Text>
        </View>
      )}
    </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  flex:{ flex: 1 },
  learnMoreText: {
    fontSize: theme.fontsize.reg,
    fontFamily: theme.fontFamily.robotoRegular,
    color: Color.background.textGray,
    lineHeight: theme.spacing.xlg,
  },
  learnMoreLink: {
    fontSize: theme.fontsize.reg,
    fontFamily: theme.fontFamily.robotoRegular,
    fontWeight: theme.fontweight.semiBold,
    color: theme.colors.secondary,
    textDecorationLine: "underline",
  },
  learnMoreContainer: {
    marginTop: theme.margin.md,
  },
  faqQuestionContainer: {
    marginTop: theme.margin.md,
    borderWidth: 1,
    borderColor: COLORS.paleGray,
    borderRadius: theme.radius.xs,
    padding: theme.spacing.md,
  },
  faqContentContainer: {
    paddingHorizontal: theme.spacing.md,
    paddingBottom: theme.spacing.md,
    scrollbarWidth: "thin"
  },
  rowApart: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  faqQuestionTxt: {
    fontFamily: theme.fontFamily.robotoMedium,
    fontWeight: theme.fontweight.regular,
    fontSize: theme.fontsize.cs,
    color: COLORS.gray[600],
  },
  faqAnswerTxt: {
    fontFamily: theme.fontFamily.robotoRegular,
    fontSize: theme.fontsize.cs,
    color: COLORS.gray[600],
    lineHeight: theme.spacing.xl,
    marginTop: theme.spacing.reg,
  },
  faqDropdownCollapsedIcon: {
    width: theme.spacing.cs,
    aspectRatio: 1,
    resizeMode: "contain",
  },
  faqDropdownExpandIcon: { transform: [{ rotate: "180deg" }] },
  link: {
    color: COLORS.vividBlue,
    textDecorationLine: "underline",
    ...(Platform.OS === "web" ? ({ cursor: "pointer" } as any) : {}),
  },
});

export default FaqSection;
